import { render, staticRenderFns } from "./b_UpgradeProfile.vue?vue&type=template&id=7e12798d&scoped=true&"
import script from "./b_UpgradeProfile.vue?vue&type=script&lang=js&"
export * from "./b_UpgradeProfile.vue?vue&type=script&lang=js&"
import style0 from "./b_UpgradeProfile.vue?vue&type=style&index=0&id=7e12798d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e12798d",
  null
  
)

export default component.exports